function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.857 5C3.07 5 0 8.134 0 12s3.07 7 6.857 7h10.286C20.93 19 24 15.866 24 12s-3.07-7-6.857-7H6.857zm0 12.25C9.697 17.25 12 14.9 12 12S9.697 6.75 6.857 6.75 1.714 9.1 1.714 12s2.303 5.25 5.143 5.25z"
});

function SvgBoolean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgBoolean;